module.exports = __webpack_public_path__ + "img/maxtreinamentosefisc4.4ff2acfe.jpeg";